define(['modules/common/controls/control'], (Control) => Control.extend({

    tagName: 'input',
    attributes: {type: 'checkbox'},

    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.$el.is(':checked'));
                };
                view.$el.on('change', this.callback);
            },
            unbind (view) {
                view.$el.off('change', this.callback);
            },
            routine (view, value) {
                view.$el.prop('checked', Boolean(value));
            }
        },
        enabled (view, value) {
            view.$el.attr('disabled', !value);
        },
        toggle (view, value) {
            view.$el.toggle(Boolean(value));
        }
    },

    render () {
        Control.prototype.render.apply(this, arguments);

        this.$el.empty();

        return this;
    }

}));
